module.exports = __webpack_public_path__ + "static/media/RecomendaPremium.e7aa688e.png";